import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import type { PreparedStarterInfo } from '@racemap/utilities/functions/timing';
import type { Immutable } from 'immer';
import type { Column } from '../TableBody';
import { type Sorting, TableHeaderCellBody } from '../TableHeaderCell';
import { TextCell } from './BasicCell';

function NameColComponent({ starterInfo }: { starterInfo: Immutable<PreparedStarterInfo> }) {
  return <Cell title={starterInfo?.name}>{starterInfo?.name}</Cell>;
}

export function getNameCol(windowWidth: number): Column {
  return {
    key: 'name',
    title: 'Name',
    width: windowWidth < 660 ? 100 : 120,
    render: function renderer(row: Immutable<PreparedStarterInfo>) {
      return <NameColComponent starterInfo={row} />;
    },
    headerRender: function renderer(column: Column, sorting: Sorting | null) {
      return <HeaderCell column={column} sorting={sorting} />;
    },
    sorter: (a: Immutable<PreparedStarterInfo>, b: Immutable<PreparedStarterInfo>) =>
      a?.name.localeCompare(b?.name),
  };
}

const Cell = styled(TextCell)`
  border-right: 1px solid ${RacemapColors.LightGray};
  height: 100%;
  display: flex;
  align-items: center;
  white-space: break-spaces;
`;

const HeaderCell = styled(TableHeaderCellBody)`
  border-right: solid 1px ${RacemapColors.LightGray};
`;
